<template>
  <article>
    
              <span class="lote_btn" v-if="item != undefined && item.length > 0">
                <v-tooltip top :close-delay="500" allow-overflow>
                  <v-chip
                        slot="activator"
                        small
                        color="grey darken-1"
                        text-color="white"
                        @click.native="openTabelaParcela(item)"
                        >
                      Visualizar
                  </v-chip>
                  <span>Visualizar tabela de lotes</span>
                </v-tooltip>  
              </span>
              <span class="lote_btn" v-else>Sem informações</span>
          <v-dialog @keydown.esc="openDialog = false" v-model="openDialog" max-width="500px">
            <v-card>
            <v-card-title>
                <span><strong>Lotes</strong></span>
                <v-spacer></v-spacer>
                <v-btn icon dark   @click.native="openDialog=false">
                        <v-icon color="red">close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-container grid-list-md>
                <v-layout row wrap>
                    <v-flex xs12 sm12 md12>
                    <table border="1" class="table_vencimento">
                      <thead>
                        <tr>
                          <th colspan="3">Tabela de inf. do Lote</th>
                        </tr>
                        <tr>
                          <th colspan="1">Número do Lote</th>
                          <th colspan="1">Vencimento</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(lote,i) in item" :key="i">
                          <td class="text-xs-center">{{lote.nLote}}</td>
                          <td class="text-xs-center">{{lote.dVal.substring(0, lote.dVal.indexOf("T")).split('-').reverse().join('/')}}</td>
                        </tr>
                      </tbody>
                    </table>
                    </v-flex>
                </v-layout>
                </v-container>
            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn color="primary" flat @click.stop="openDialog=false">Fechar</v-btn>
                <!-- <v-btn color="success"  @click.stop="newColumn()">Criar</v-btn> -->
            </v-card-actions>
            </v-card>
        </v-dialog>

  </article>
</template>
<script>
export default {
  props: ["item", "empresa", "component"],
  beforeMount() {},
  data: () => ({
    openDialog: false
  }),
  methods: {
    openTabelaParcela: function() {
      this.openDialog = true;
    }
  }
};
</script>
<style>
.duplicata_sem_dt_venc {
  color: red;
}
.table_vencimento {
  border-collapse: collapse;
  width: 100%;
}
.table_vencimento td,
.table_vencimento th {
  border: 1px solid black;
}
.table_vencimento td {
  padding: 0px 5px;
}
.table_vencimento td.valorReais {
  position: relative;
}
.table_vencimento td.valorReais:before {
  content: "R$";
  left: 4px;
  position: absolute;
}
.lote_btn span.v-chip__content {
  cursor: pointer;
  font-size: 1.7em !important;
}
</style>
  



// WEBPACK FOOTER //
// src/components/dataTable/commonTable/coluna_lote/Coluna_lote.vue